import { styled } from '@mui/material'
import { ReactNode, memo } from 'react'
import { transientOptions } from 'styles/TransientOptions'
import { ReactComponent as IconSelected } from './assets/select-selected.svg'
import { ExSelectValue } from '.'

const ExSelectItemWrap = styled('div', transientOptions)<{
  $selected?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  font-size: 14px;
  color: ${({ $selected }) =>
    $selected ? 'rgba(160, 238, 9, 1)' : 'rgba(229, 234, 238, 1)'};
  padding: 0 8px;
  width: 100%;
  cursor: pointer;
  user-select: none;
  transition: color 0.2s ease-in-out;

  &:hover {
    background-color: #2a3139;
  }
`

export interface ExSelectItemProps {
  value: ExSelectValue
  selected?: boolean
  children?: ReactNode
  onClick?: (val: ExSelectValue) => void
}

export const ExSelectItem = memo<ExSelectItemProps>(
  ({ value, selected, children, onClick }) => {
    return (
      <ExSelectItemWrap
        $selected={selected}
        onClick={() => {
          onClick && onClick(value)
        }}
      >
        {children}
        {selected && <IconSelected />}
      </ExSelectItemWrap>
    )
  },
)
